(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cosmos-orbit-rings"] && !Shopify.designMode) return;
  try {
    class CosmosOrbitRings extends HTMLElement {
    connectedCallback() {
      this.syncRings();
      this.observer = new MutationObserver(() => this.syncRings());
      this.observe();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    observe() {
      this.observer?.observe(this, { childList: true, subtree: true });
    }

    syncRings() {
      this.observer?.disconnect();

      const mediaItems = Array.from(
        this.querySelectorAll('.image-block, deferred-media.size-style, .video-placeholder-wrapper'),
      ).filter((mediaItem) => mediaItem.closest('cosmos-orbit-rings') === this);
      const source = this.querySelector(':scope > .cosmos-orbit-rings-source');
      const rings = [1, 2, 3, 4].map((number) => {
        let ring = this.querySelector(`:scope > .cosmos-orbit-ring-${number}`);

        if (!ring) {
          ring = document.createElement('div');
          ring.className = `cosmos-orbit-ring cosmos-orbit-ring-${number}`;
          ring.dataset.orbitRing = String(number);
          this.insertBefore(ring, source);
        }

        return ring;
      });
      const groups = [[], [], [], []];

      mediaItems.forEach((mediaItem, index) => {
        let ringIndex = 3;

        if (index === 0) ringIndex = 0;
        if (index >= 1 && index <= 2) ringIndex = 1;
        if (index >= 3 && index <= 7) ringIndex = 2;

        groups[ringIndex].push(mediaItem);
      });

      groups.forEach((group, ringIndex) => {
        group.forEach((mediaItem, mediaItemIndex) => {
          mediaItem.style.setProperty('--cosmos-orbit-angle', `${(360 / group.length) * mediaItemIndex}deg`);
          if (mediaItem.parentElement !== rings[ringIndex]) rings[ringIndex].append(mediaItem);
        });
      });

      this.observe();
    }
  }

  if (!customElements.get('cosmos-orbit-rings')) {
    customElements.define('cosmos-orbit-rings', CosmosOrbitRings);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    if (!window.mainBuyNowAddThenCheckoutInitialized) {
    window.mainBuyNowAddThenCheckoutInitialized = true;

    document.addEventListener('click', (event) => {
      const buyNowButton = event.target.closest('[data-buy-now-button]');

      if (!(buyNowButton instanceof HTMLButtonElement)) return;
      if (buyNowButton.disabled) return;

      const productForm = buyNowButton.closest('product-form-component');
      const addToCartButton = productForm?.querySelector('[ref="addToCartButton"]');

      if (!(productForm instanceof HTMLElement)) return;
      if (!(addToCartButton instanceof HTMLButtonElement)) return;
      if (addToCartButton.disabled) return;

      productForm.dataset.redirectToCheckout = 'true';
      addToCartButton.click();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["animated-number-with-text"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.animatedNumberWithTextInitialized) return;
    window.animatedNumberWithTextInitialized = true;

    const animateNumber = (element) => {
      const target = Number(element.dataset.animatedNumber);

      if (!Number.isFinite(target)) return;

      const decimalPart = String(target).split('.')[1];
      const formatter = new Intl.NumberFormat(document.documentElement.lang, {
        minimumFractionDigits: decimalPart ? decimalPart.length : 0,
        maximumFractionDigits: decimalPart ? decimalPart.length : 0,
      });
      element.textContent = formatter.format(target);
      element.style.setProperty('--animated-number-width', `${element.getBoundingClientRect().width}px`);
      const setValue = (value) => {
        element.textContent = formatter.format(value);
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setValue(target);
        return;
      }

      const duration = 1500;
      const startTime = performance.now();
      const update = (time) => {
        const progress = Math.min((time - startTime) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);

        setValue(target * easedProgress);

        if (progress < 1) requestAnimationFrame(update);
      };

      requestAnimationFrame(update);
    };

    const initialize = (root = document) => {
      root
        .querySelectorAll('.animated-number-with-text__number:not([data-animated-number-initialized])')
        .forEach((element) => {
          element.dataset.animatedNumberInitialized = 'true';

          if (!window.IntersectionObserver) {
            animateNumber(element);
            return;
          }

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                observer.unobserve(entry.target);
                animateNumber(entry.target);
              });
            },
            { threshold: 0.2 }
          );

          observer.observe(element);
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["app-controls"] && !Shopify.designMode) return;
  try {
    class AppControlsComponent extends HTMLElement {
    connectedCallback() {
      this.activeIndex = 0;
      this.bottomTransitionId = 0;
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, { childList: true, subtree: true });
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.observer?.disconnect();
      this.cancelBottomAnimations();
    }

    getItems() {
      const tabsRegion = this.querySelector(':scope > [data-app-controls-tabs]');
      const panelsRegion = this.querySelector(':scope > [data-app-controls-panels]');
      const bottomPanelsRegion = this.querySelector(':scope > [data-app-controls-bottom-panels]');
      const tabs = tabsRegion
        ? Array.from(tabsRegion.querySelectorAll(':scope > .app-controls-tab-item > [data-app-controls-tab]'))
        : [];
      const panels = panelsRegion ? Array.from(panelsRegion.children) : [];
      const bottomPanels = bottomPanelsRegion ? Array.from(bottomPanelsRegion.children) : [];

      return { tabs, panels, bottomPanels };
    }

    sync() {
      const { tabs, panels, bottomPanels } = this.getItems();
      const pairCount = Math.min(tabs.length, panels.length);

      if (pairCount === 0) {
        tabs.forEach((tab) => this.updateTab(tab, null, false));
        panels.forEach((panel) => this.updatePanel(panel, null, false));
        bottomPanels.forEach((panel) => this.updateBottomPanel(panel, null, false));
        return;
      }

      this.activeIndex = Math.min(this.activeIndex, pairCount - 1);

      tabs.forEach((tab, index) => {
        const panel = panels[index];
        const isActive = index === this.activeIndex && index < pairCount;

        this.updateTab(tab, panel, bottomPanels[index], isActive);
        if (panel) this.updatePanel(panel, tab, isActive);
        if (bottomPanels[index]) this.updateBottomPanel(bottomPanels[index], tab, isActive);
      });

      panels.slice(tabs.length).forEach((panel) => this.updatePanel(panel, null, false));
      bottomPanels.slice(tabs.length).forEach((panel) => this.updateBottomPanel(panel, null, false));
      this.syncMediaPlayback([...panels, ...bottomPanels]);
    }

    updateTab(tab, panel, bottomPanel, isActive) {
      const isPaired = panel instanceof HTMLElement;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      tab.setAttribute('aria-disabled', isPaired ? 'false' : 'true');

      if (!isPaired) {
        tab.removeAttribute('aria-controls');
        return;
      }

      if (!panel.id) panel.id = `${this.dataset.appControlsId}-panel-${this.panelIndex(panel) + 1}`;
      const controlledPanelIds = [panel.id];
      if (bottomPanel instanceof HTMLElement) {
        if (!bottomPanel.id) {
          bottomPanel.id = `${this.dataset.appControlsId}-bottom-panel-${this.bottomPanelIndex(bottomPanel) + 1}`;
        }
        controlledPanelIds.push(bottomPanel.id);
      }
      tab.setAttribute('aria-controls', controlledPanelIds.join(' '));
    }

    updatePanel(panel, tab, isActive) {
      panel.classList.add('app-controls-panel');
      panel.setAttribute('role', 'tabpanel');
      panel.toggleAttribute('hidden', !isActive);

      if (!(tab instanceof HTMLElement)) {
        panel.removeAttribute('aria-labelledby');
        return;
      }

      if (!tab.id) tab.id = `${this.dataset.appControlsId}-tab-${this.tabIndex(tab) + 1}`;
      panel.setAttribute('aria-labelledby', tab.id);
    }

    updateBottomPanel(panel, tab, isActive) {
      panel.classList.add('app-controls-bottom-panel');
      panel.setAttribute('role', 'region');
      panel.toggleAttribute('hidden', !isActive);

      if (!(tab instanceof HTMLElement)) {
        panel.removeAttribute('aria-labelledby');
        return;
      }

      if (!tab.id) tab.id = `${this.dataset.appControlsId}-tab-${this.tabIndex(tab) + 1}`;
      panel.setAttribute('aria-labelledby', tab.id);
    }

    tabIndex(tab) {
      return this.getItems().tabs.indexOf(tab);
    }

    panelIndex(panel) {
      return this.getItems().panels.indexOf(panel);
    }

    bottomPanelIndex(panel) {
      return this.getItems().bottomPanels.indexOf(panel);
    }

    activate(index, moveFocus = false) {
      const { tabs, panels, bottomPanels } = this.getItems();
      const pairCount = Math.min(tabs.length, panels.length);
      if (index < 0 || index >= pairCount) return;

      const previousIndex = this.activeIndex;
      this.activeIndex = index;
      this.syncWithoutBottomPanels();
      this.transitionBottomPanels(previousIndex, index, tabs, bottomPanels);
      if (moveFocus) tabs[index].focus();
    }

    syncWithoutBottomPanels() {
      const bottomPanelsRegion = this.querySelector(':scope > [data-app-controls-bottom-panels]');
      const bottomPanels = bottomPanelsRegion ? Array.from(bottomPanelsRegion.children) : [];
      const bottomPanelState = bottomPanels.map((panel) => panel.hidden);

      this.sync();
      bottomPanels.forEach((panel, index) => panel.toggleAttribute('hidden', bottomPanelState[index]));
    }

    async transitionBottomPanels(previousIndex, nextIndex, tabs, bottomPanels) {
      const transitionId = ++this.bottomTransitionId;
      this.cancelBottomAnimations();

      const previousPanel = bottomPanels[previousIndex];
      const nextPanel = bottomPanels[nextIndex];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let exitAnimation;

      if (previousIndex === nextIndex || reduceMotion || typeof Element.prototype.animate !== 'function') {
        bottomPanels.forEach((panel, index) => this.updateBottomPanel(panel, tabs[index], index === nextIndex));
        this.syncMediaPlayback(bottomPanels);
        return;
      }

      if (previousPanel instanceof HTMLElement && !previousPanel.hidden) {
        exitAnimation = previousPanel.animate(
          [
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(16px)' },
          ],
          { duration: 180, easing: 'ease-in', fill: 'both' },
        );
        this.bottomAnimations = [exitAnimation];

        try {
          await exitAnimation.finished;
        } catch (error) {
          return;
        }
      }

      if (transitionId !== this.bottomTransitionId) return;

      bottomPanels.forEach((panel, index) => this.updateBottomPanel(panel, tabs[index], index === nextIndex));
      this.syncMediaPlayback(bottomPanels);
      this.bottomAnimations = [];
      exitAnimation?.cancel();
      if (!(nextPanel instanceof HTMLElement)) return;

      const enterAnimation = nextPanel.animate(
        [
          { opacity: 0, transform: 'translateY(16px)' },
          { opacity: 1, transform: 'translateY(0)' },
        ],
        { duration: 220, easing: 'ease-out', fill: 'both' },
      );
      this.bottomAnimations = [enterAnimation];

      try {
        await enterAnimation.finished;
      } catch (error) {
        return;
      }

      if (transitionId === this.bottomTransitionId) {
        enterAnimation.cancel();
        this.bottomAnimations = [];
      }
    }

    cancelBottomAnimations() {
      this.bottomAnimations?.forEach((animation) => animation.cancel());
      this.bottomAnimations = [];
    }

    syncMediaPlayback(panels) {
      panels.forEach((panel) => {
        if (panel.hidden) {
          this.pausePanelMedia(panel);
        } else {
          this.playPanelMedia(panel);
        }
      });
    }

    playPanelMedia(panel) {
      requestAnimationFrame(() => {
        if (panel.hidden) return;

        panel.querySelectorAll('deferred-media[autoplay]').forEach((media) => {
          if (typeof media.syncAutoplay === 'function') media.syncAutoplay();
        });
      });
    }

    pausePanelMedia(panel) {
      panel.querySelectorAll('deferred-media[autoplay]').forEach((media) => {
        if (typeof media.pauseMedia === 'function') media.pauseMedia();
      });
    }

    handleClick(event) {
      const tab = event.target instanceof Element ? event.target.closest('[data-app-controls-tab]') : null;
      if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

      this.activate(this.tabIndex(tab));
    }

    handleKeydown(event) {
      const tab = event.target instanceof Element ? event.target.closest('[data-app-controls-tab]') : null;
      if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

      const { tabs, panels } = this.getItems();
      const pairCount = Math.min(tabs.length, panels.length);
      const currentIndex = tabs.indexOf(tab);
      if (currentIndex < 0 || currentIndex >= pairCount) return;

      const isRtl = getComputedStyle(this).direction === 'rtl';
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex += isRtl ? -1 : 1;
      if (event.key === 'ArrowLeft') nextIndex += isRtl ? 1 : -1;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = pairCount - 1;
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      this.activate((nextIndex + pairCount) % pairCount, true);
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element)) return;

      const { tabs, panels, bottomPanels } = this.getItems();
      const tabIndex = tabs.findIndex((tab) => tab === event.target || tab.contains(event.target));
      if (tabIndex >= 0) {
        this.activate(tabIndex);
        return;
      }

      const panelIndex = panels.findIndex((panel) => panel === event.target || panel.contains(event.target));
      if (panelIndex >= 0) {
        this.activate(panelIndex);
        return;
      }

      const bottomPanelIndex = bottomPanels.findIndex(
        (panel) => panel === event.target || panel.contains(event.target),
      );
      if (bottomPanelIndex >= 0) this.activate(bottomPanelIndex);
    }
  }

  if (!customElements.get('app-controls-component')) {
    customElements.define('app-controls-component', AppControlsComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!customElements.get('cart-note')) {
      class CartNote extends HTMLElement {
        constructor() {
          super();
          this._debounceId = null;
          this._onInput = this._onInput.bind(this);
        }

        connectedCallback() {
          this._textarea = this.querySelector('textarea[name="note"]');
          if (this._textarea) {
            this._textarea.addEventListener('input', this._onInput);
          }
        }

        disconnectedCallback() {
          if (this._textarea) {
            this._textarea.removeEventListener('input', this._onInput);
          }

          if (this._debounceId) {
            clearTimeout(this._debounceId);
            this._debounceId = null;
          }
        }

        _onInput(event) {
          if (!(event.target instanceof HTMLTextAreaElement)) return;

          if (this._debounceId) {
            clearTimeout(this._debounceId);
          }

          const note = event.target.value;

          this._debounceId = window.setTimeout(async () => {
            try {
              await fetch(Theme.routes.cart_update_url, {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ note }),
              });
            } catch (error) {}
          }, 200);
        }
      }

      customElements.define('cart-note', CartNote);
    }

    if (window.__cartDrawerShellCloseInit) return;
    window.__cartDrawerShellCloseInit = true;
    const syncScrollLock = () => {
      const hasOpenSearchDrawer = document.querySelector('.search-drawer.header-drawer-shell--search.is-open');
      const hasOpenCartDrawer = document.querySelector('.cart-drawer-shell.header-drawer-shell--cart.is-open');
      const hasOpenCustomHeaderDrawer = document.querySelector('.custom-header__drawer.is-open');
      const shouldLockScroll = Boolean(hasOpenSearchDrawer || hasOpenCartDrawer || hasOpenCustomHeaderDrawer);
      document.documentElement.toggleAttribute('scroll-lock', shouldLockScroll);
    };

    const closeDrawer = () => {
      const drawer = document.querySelector('.cart-drawer-shell.header-drawer-shell--cart');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      syncScrollLock();
    };

    const RECENTLY_VIEWED_STORAGE_KEY = 'viewedProducts';
    const RECENTLY_VIEWED_SECTION_ID = 'cart-recently-viewed';
    const RECENTLY_VIEWED_LIMIT = 4;
    let recentlyViewedRequestId = 0;

    const getRecentlyViewedProductIds = () => {
      try {
        const parsed = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY) || '[]');
        if (!Array.isArray(parsed)) return [];

        return parsed
          .map((id) => String(id).trim())
          .filter((id) => id !== '')
          .slice(0, RECENTLY_VIEWED_LIMIT);
      } catch (error) {
        return [];
      }
    };

    const renderRecentlyViewedProducts = async (drawer) => {
      if (!drawer) return;

      const targetContainer = drawer.querySelector('[data-cart-recently-viewed-items]');
      if (!targetContainer) return;

      const viewedProductIds = getRecentlyViewedProductIds();
      if (viewedProductIds.length === 0) {
        targetContainer.replaceChildren();
        return;
      }

      const currentRequestId = ++recentlyViewedRequestId;
      const searchRoute = Theme && Theme.routes ? Theme.routes.search_url : '/search';
      const sectionUrl = new URL(searchRoute || '/search', window.location.origin);
      sectionUrl.searchParams.set('q', viewedProductIds.map((id) => `id:${id}`).join(' OR '));
      sectionUrl.searchParams.set('resources[type]', 'product');
      sectionUrl.searchParams.set('section_id', RECENTLY_VIEWED_SECTION_ID);

      try {
        const response = await fetch(sectionUrl.toString(), {
          headers: {
            Accept: 'text/html',
          },
        });
        if (!response.ok) return;

        const html = await response.text();
        if (currentRequestId !== recentlyViewedRequestId) return;

        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const nextItemsContainer = parsedDocument.querySelector('[data-cart-recently-viewed-items]');
        if (!nextItemsContainer) {
          targetContainer.replaceChildren();
          return;
        }

        targetContainer.replaceChildren(...Array.from(nextItemsContainer.children).map((item) => item.cloneNode(true)));
      } catch (error) {}
    };

    const setActiveTab = (drawer, activeTab) => {
      if (!drawer || !activeTab) return;
      const tabs = drawer.querySelectorAll('[data-cart-tab]');
      const panels = drawer.querySelectorAll('[data-cart-panel]');
      const targetPanelId = activeTab.getAttribute('aria-controls');
      const footer = drawer.querySelector('[data-cart-footer]');
      const miniCartPanel = drawer.querySelector('[id^="MiniCart-"][data-cart-panel]');

      tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetPanelId;
      });

      if (footer) {
        footer.hidden = !miniCartPanel || targetPanelId !== miniCartPanel.id;
      }

      if (targetPanelId && targetPanelId.indexOf('RecentlyViewed-') === 0) {
        renderRecentlyViewedProducts(drawer);
      }
    };

    document.querySelectorAll('.cart-drawer-shell.header-drawer-shell--cart').forEach((drawer) => {
      const defaultTab = drawer.querySelector('[data-cart-tab][aria-expanded="true"]');
      const firstTab = drawer.querySelector('[data-cart-tab]');
      setActiveTab(drawer, defaultTab || firstTab);
      renderRecentlyViewedProducts(drawer);
    });

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-cart-tab]');
      if (tab) {
        const drawer = tab.closest('.cart-drawer-shell.header-drawer-shell--cart');
        setActiveTab(drawer, tab);
        return;
      }

      const closeButton = event.target.closest('[data-cart-drawer-close], [data-header-drawer-close]');
      if (closeButton) {
        closeDrawer();
        return;
      }

      const mask = event.target.closest('.cart-drawer-shell.header-drawer-shell--cart .header-drawer-shell__mask');
      if (mask) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["currencies-switch"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__currenciesSwitchInit) return;
    window.__currenciesSwitchInit = true;

    const getRoots = () => Array.from(document.querySelectorAll('[data-currencies-switch-root]'));
    const getRootSectionId = (root) => {
      const sectionIdClass = Array.from(root?.classList || []).find((className) =>
        className.startsWith('multilingual-root-'),
      );
      return sectionIdClass ? sectionIdClass.replace('multilingual-root-', '') : '';
    };
    const getRootForm = (root) => {
      const sectionId = getRootSectionId(root);
      return sectionId ? document.getElementById(`CurrenciesSwitchForm-${sectionId}`) : null;
    };
    const submitCountry = (root, countryCode) => {
      const form = getRootForm(root);
      const input = form?.querySelector('[data-currencies-country-input]');
      if (countryCode && form && input) {
        input.value = countryCode;
        form.submit();
      }
    };
    const hideAutoSuggest = (root) => {
      if (!root) return;
      const panel = root.querySelector('[data-currencies-auto-suggest]');
      if (!panel) return;
      panel.hidden = true;
      root.removeAttribute('data-currencies-target-country');
    };
    const showAutoSuggest = (root, targetCountry, targetCountryName) => {
      if (!root || !targetCountry) return;
      const panel = root.querySelector('[data-currencies-auto-suggest]');
      const textNode = root.querySelector('[data-currencies-auto-suggest-text]');
      const switchButton = root.querySelector('[data-currencies-auto-switch]');
      const stayButton = root.querySelector('[data-currencies-auto-stay]');
      if (!panel || !textNode || !switchButton || !stayButton) return;

      root.setAttribute('data-currencies-target-country', targetCountry);
      textNode.textContent = `We detected your region may be ${targetCountryName}.`;
      switchButton.textContent = `Switch to ${targetCountryName}`;
      stayButton.textContent = 'Stay on current region';
      panel.hidden = false;
    };
    const openModal = () => {
      getRoots().forEach((root) => {
        root.style.display = 'block';
        root.setAttribute('aria-hidden', 'false');
      });
    };
    const closeModal = () => {
      getRoots().forEach((root) => {
        root.style.display = 'none';
        root.setAttribute('aria-hidden', 'true');
      });
    };

    document.addEventListener('click', (event) => {
      const openTrigger = event.target.closest('[data-currencies-switch-open]');
      if (openTrigger) {
        openModal();
        return;
      }

      const closeTrigger = event.target.closest('[data-currencies-switch-close]');
      if (closeTrigger) {
        closeModal();
        return;
      }

      const countryItem = event.target.closest('[data-country-code]');
      if (countryItem) {
        const countryCode = countryItem.getAttribute('data-country-code');
        const root = countryItem.closest('[data-currencies-switch-root]');
        hideAutoSuggest(root);
        submitCountry(root, countryCode);
        return;
      }

      const autoSwitchButton = event.target.closest('[data-currencies-auto-switch]');
      if (autoSwitchButton) {
        const root = autoSwitchButton.closest('[data-currencies-switch-root]');
        const targetCountry = root?.getAttribute('data-currencies-target-country');
        if (targetCountry) {
          submitCountry(root, targetCountry);
        }
        return;
      }

      const autoStayButton = event.target.closest('[data-currencies-auto-stay]');
      if (autoStayButton) {
        const root = autoStayButton.closest('[data-currencies-switch-root]');
        hideAutoSuggest(root);
        closeModal();
        return;
      }

      const mask = event.target.closest('[data-currencies-switch-root]');
      if (mask && event.target === mask) {
        hideAutoSuggest(mask);
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    });

    if (window.Shopify && window.Shopify.designMode) return;

    const readBrowserCountryCodes = () => {
      const localeList = Array.from(new Set([...(navigator.languages || []), navigator.language].filter(Boolean)));
      const fallbackLanguageToCountry = {
        en: 'US',
        zh: 'CN',
        fr: 'FR',
        de: 'DE',
        es: 'ES',
        it: 'IT',
        ja: 'JP',
        ko: 'KR',
        pt: 'PT',
        nl: 'NL',
        ru: 'RU',
      };
      const browserCountryCodes = [];

      localeList.forEach((localeCode) => {
        let regionCode = '';
        try {
          const locale = new Intl.Locale(localeCode);
          regionCode = (locale.region || '').toUpperCase();
          if (!regionCode && locale.language && fallbackLanguageToCountry[locale.language]) {
            regionCode = fallbackLanguageToCountry[locale.language];
          }
        } catch (_error) {
          const normalized = String(localeCode).replace('_', '-');
          const parts = normalized.split('-');
          if (parts.length > 1) {
            regionCode = parts[parts.length - 1].toUpperCase();
          } else if (fallbackLanguageToCountry[parts[0]]) {
            regionCode = fallbackLanguageToCountry[parts[0]];
          }
        }

        if (regionCode && browserCountryCodes.includes(regionCode) === false) {
          browserCountryCodes.push(regionCode);
        }
      });

      return browserCountryCodes;
    };

    const root = getRoots()[0];
    if (!root) return;

    const currentCountry = (root.getAttribute('data-current-country') || '').toUpperCase();
    if (!currentCountry) return;

    const countryItems = Array.from(root.querySelectorAll('[data-country-code]'));
    const availableCountryMap = {};
    countryItems.forEach((item) => {
      const countryCode = (item.getAttribute('data-country-code') || '').toUpperCase();
      const countryName = item.getAttribute('data-country-name') || countryCode;
      if (countryCode) {
        availableCountryMap[countryCode] = countryName;
      }
    });

    const browserCountryCodes = readBrowserCountryCodes();
    const targetCountry = browserCountryCodes.find(
      (countryCode) => availableCountryMap[countryCode] && countryCode !== currentCountry,
    );
    if (!targetCountry) return;

    const promptCacheKey = `currencies-switch-auto-prompt-${currentCountry}-${targetCountry}`;
    let hasPromptedInSession = false;
    try {
      hasPromptedInSession = window.sessionStorage.getItem(promptCacheKey) === '1';
    } catch (_error) {}
    if (hasPromptedInSession) return;

    try {
      window.sessionStorage.setItem(promptCacheKey, '1');
    } catch (_error) {}

    const targetCountryName = availableCountryMap[targetCountry] || targetCountry;
    showAutoSuggest(root, targetCountry, targetCountryName);
    openModal();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    const initSortByPopModal = (root = document) => {
    root.querySelectorAll('[data-sort-by-pop-modal]').forEach((modal) => {
      if (modal.dataset.sortByPopInitialized === 'true') {
        return;
      }

      const closeButton = modal.querySelector('[data-sort-by-pop-close]');
      const modalWrapper = modal.parentElement;
      const triggerButton = modalWrapper?.querySelector('[data-sort-by-pop-trigger]');

      if (!closeButton || !triggerButton) {
        return;
      }

      modal.dataset.sortByPopInitialized = 'true';
      modal.dataset.sortByPopExpanded = 'false';
      const expandedWidth = 320;
      const modalInner = modal.firstElementChild;

      const getExpandedHeight = () => {
        if (!modalInner) {
          return 0;
        }

        return modalInner.scrollHeight;
      };

      const openModal = () => {
        if (modal.dataset.sortByPopExpanded === 'true') {
          return;
        }

        modal.dataset.sortByPopExpanded = 'true';
        modal.removeAttribute('inert');
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.remove('pointer-events-none');
        modal.style.overflow = 'hidden';
        modal.style.width = '0px';
        modal.style.height = '0px';

        requestAnimationFrame(() => {
          const expandedHeight = getExpandedHeight();
          modal.style.width = `${expandedWidth}px`;
          modal.style.height = `${expandedHeight}px`;
        });
      };

      const closeModal = (event) => {
        event?.preventDefault();

        if (modal.dataset.sortByPopExpanded !== 'true') {
          return;
        }

        modal.dataset.sortByPopExpanded = 'false';
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('inert', '');
        modal.classList.add('pointer-events-none');
        const expandedHeight = getExpandedHeight();
        modal.style.width = `${expandedWidth}px`;
        modal.style.height = `${expandedHeight}px`;
        modal.style.overflow = 'hidden';

        requestAnimationFrame(() => {
          modal.style.width = '0px';
          modal.style.height = '0px';
        });
      };

      triggerButton.addEventListener('click', () => {
        if (modal.dataset.sortByPopExpanded === 'true') {
          closeModal();
          return;
        }

        openModal();
      });

      closeButton.addEventListener('click', closeModal);

      document.addEventListener('click', (event) => {
        if (modal.dataset.sortByPopExpanded !== 'true') {
          return;
        }

        if (!(event.target instanceof Node)) {
          return;
        }

        if (modal.contains(event.target) || triggerButton.contains(event.target)) {
          return;
        }

        closeModal();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
          return;
        }

        closeModal();
      });

      window.addEventListener('resize', () => {
        if (modal.dataset.sortByPopExpanded !== 'true') {
          return;
        }

        const expandedHeight = getExpandedHeight();
        modal.style.height = `${expandedHeight}px`;
      });
    });
  };

  const initFilterDrawer = (root = document) => {
    const drawer = root.querySelector('#filter-drawer');
    const triggerButton = root.querySelector('[data-filter-drawer-open]');

    if (!drawer || !triggerButton || drawer.dataset.filterDrawerInitialized === 'true') {
      return;
    }

    const closeButton = drawer.querySelector('[data-header-drawer-close]');
    const mask = drawer.querySelector('.header-drawer-shell__mask');

    if (!closeButton || !mask) {
      return;
    }

    drawer.dataset.filterDrawerInitialized = 'true';

    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    };

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    };

    triggerButton.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', closeDrawer);
    mask.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initSortByPopModal();
        initFilterDrawer();
      },
      { once: true }
    );
  } else {
    initSortByPopModal();
    initFilterDrawer();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSortByPopModal(event.target);
    initFilterDrawer(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["go-back"] && !Shopify.designMode) return;
  try {
    if (!window.__goBackBlockBound) {
    window.__goBackBlockBound = true;

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('[data-go-back-link]');
      if (!link) return;

      event.preventDefault();

      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      const fallbackUrl = link.getAttribute('href');
      if (fallbackUrl) {
        window.location.assign(fallbackUrl);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["search-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__searchDrawerCloseInit) return;
    window.__searchDrawerCloseInit = true;
    const syncScrollLock = () => {
      const hasOpenSearchDrawer = document.querySelector('.search-drawer.header-drawer-shell--search.is-open');
      const hasOpenCartDrawer = document.querySelector('.cart-drawer-shell.header-drawer-shell--cart.is-open');
      const hasOpenCustomHeaderDrawer = document.querySelector('.custom-header__drawer.is-open');
      const shouldLockScroll = Boolean(hasOpenSearchDrawer || hasOpenCartDrawer || hasOpenCustomHeaderDrawer);
      document.documentElement.toggleAttribute('scroll-lock', shouldLockScroll);
    };
    const PAGES_LIMIT = 4;
    const COLLECTIONS_LIMIT = 4;
    const PRODUCTS_LIMIT = 4;
    const VISIBILITY_TRANSITION_MS = 220;
    let pageSearchAbortController = null;
    let pageSearchDebounceTimer;
    let activePageSearchRequestId = 0;
    const visibilityTimers = new WeakMap();
    const setSearchLoadingState = (body, isLoading) => {
      if (!(body instanceof HTMLElement)) return;
      body.dataset.searchPagesLoading = isLoading ? 'true' : 'false';
    };
    const getResultsCta = (body) => {
      if (!(body instanceof HTMLElement)) return null;
      const panel = body.closest('.header-drawer-shell__panel');
      if (!(panel instanceof HTMLElement)) return null;
      const resultsCta = panel.querySelector('[data-search-results-cta]');
      return resultsCta instanceof HTMLElement ? resultsCta : null;
    };
    const setAnimatedVisibility = (element, isVisible) => {
      if (!(element instanceof HTMLElement)) return;
      const existingTimer = visibilityTimers.get(element);
      if (existingTimer) {
        window.clearTimeout(existingTimer);
        visibilityTimers.delete(element);
      }

      if (isVisible) {
        element.hidden = false;
        element.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => {
          element.classList.add('is-visible');
        });
        return;
      }

      element.classList.remove('is-visible');
      element.setAttribute('aria-hidden', 'true');
      const timer = window.setTimeout(() => {
        element.hidden = true;
        visibilityTimers.delete(element);
      }, VISIBILITY_TRANSITION_MS);
      visibilityTimers.set(element, timer);
    };

    const hasSearchResults = (body) => {
      if (!body) return false;
      const pagesList = body.querySelector('[data-search-pages-list]');
      const collectionsList = body.querySelector('[data-search-collections-list]');
      const productsList = body.querySelector('[data-search-products-list]');
      if (
        !(pagesList instanceof HTMLElement) ||
        !(collectionsList instanceof HTMLElement) ||
        !(productsList instanceof HTMLElement)
      ) {
        return false;
      }
      return pagesList.children.length > 0 || collectionsList.children.length > 0 || productsList.children.length > 0;
    };

    const syncSearchEmptyTerm = (input) => {
      if (!input) return;
      const body = input.closest('.header-drawer-shell__body');
      if (!body) return;

      const termSlot = body.querySelector('[data-search-empty-term]');
      if (!termSlot) return;

      const term = input.value.trim();
      termSlot.textContent = term;
    };

    const updateSearchEmptyState = (input) => {
      if (!input) return;
      const body = input.closest('.header-drawer-shell__body');
      if (!body) return;

      const emptyState = body.querySelector('[data-search-empty-wrapper]');
      const resultsPanel = body.querySelector('[data-search-results-panel]');
      if (!(emptyState instanceof HTMLElement) || !(resultsPanel instanceof HTMLElement)) return;

      const term = input.value.trim();
      const isLoading = body.dataset.searchPagesLoading === 'true';
      const hasResults = hasSearchResults(body);
      const showEmpty = term !== '' && !isLoading && !hasResults;
      const showResultsPanel = term !== '' && (isLoading || hasResults);

      setAnimatedVisibility(emptyState, showEmpty);
      setAnimatedVisibility(resultsPanel, showResultsPanel);
    };

    const getPredictiveSearchResultsUrl = (term) => {
      const predictiveSearchPath = window.Theme?.routes?.predictive_search_url || '/search/suggest';
      const url = new URL(predictiveSearchPath, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', 'product,page,collection');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[limit]', String(Math.max(PAGES_LIMIT, COLLECTIONS_LIMIT, PRODUCTS_LIMIT)));
      url.searchParams.set('section_id', 'predictive-search');
      return url;
    };

    const getPredictiveSearchProductsJsonUrl = (term) => {
      const predictiveSearchPath = window.Theme?.routes?.predictive_search_url || '/search/suggest';
      const jsonPath = predictiveSearchPath.endsWith('.json') ? predictiveSearchPath : `${predictiveSearchPath}.json`;
      const url = new URL(jsonPath, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[limit]', String(PRODUCTS_LIMIT));
      return url;
    };

    const hideProductsResults = (body) => {
      if (!body) return;
      const productsSection = body.querySelector('[data-search-products-section]');
      const productsList = body.querySelector('[data-search-products-list]');
      const resultsCta = getResultsCta(body);
      if (!(productsSection instanceof HTMLElement) || !(productsList instanceof HTMLElement)) return;

      productsList.innerHTML = '';
      productsSection.hidden = true;
      productsSection.setAttribute('aria-hidden', 'true');
      if (resultsCta instanceof HTMLElement) {
        setAnimatedVisibility(resultsCta, false);
      }
    };

    const renderProductsResults = (body, products) => {
      if (!body) return;
      const productsSection = body.querySelector('[data-search-products-section]');
      const productsList = body.querySelector('[data-search-products-list]');
      const resultsCta = getResultsCta(body);
      if (!(productsSection instanceof HTMLElement) || !(productsList instanceof HTMLElement)) return;

      productsList.innerHTML = '';

      products.forEach((product) => {
        const row = document.createElement('div');
        row.className = 'horizontal-product flex items-center gap-4 md:gap-6 w-full';

        const mediaLink = document.createElement('a');
        mediaLink.className = 'horizontal-product__media media media--square relative overflow-hidden flex-auto';
        mediaLink.href = product.url;
        mediaLink.tabIndex = -1;

        if (product.imageSrc) {
          const image = document.createElement('img');
          image.src = product.imageSrc;
          image.alt = product.imageAlt || product.title;
          image.width = 320;
          image.height = 320;
          image.loading = 'lazy';
          mediaLink.append(image);
        }

        const details = document.createElement('div');
        details.className = 'horizontal-product__details flex flex-col justify-start gap-1d5';

        const titleWrap = document.createElement('div');
        titleWrap.className = 'flex flex-col gap-1';
        const titleBlock = document.createElement('div');
        titleBlock.className = 'block';
        if (product.vendor) {
          const vendorLabel = document.createElement('p');
          vendorLabel.className = 'text-xs text-opacity';
          vendorLabel.textContent = product.vendor;
          titleBlock.append(vendorLabel);
        }
        const titleLink = document.createElement('a');
        titleLink.href = product.url;
        titleLink.className = 'horizontal-product__title reversed-link font-medium text-base leading-tight';
        titleLink.textContent = product.title;
        titleBlock.append(titleLink);
        titleWrap.append(titleBlock);
        details.append(titleWrap);

        if (product.salePrice || product.regularPrice || product.comparePrice) {
          const priceWrap = document.createElement('div');
          priceWrap.className = 'flex flex-col gap-1';
          const priceElement = document.createElement('div');
          priceElement.className = 'price flex flex-wrap items-end gap-2 text-sm';

          if (product.comparePrice) {
            priceElement.classList.add('price--on-sale');
            const srSale = document.createElement('span');
            srSale.className = 'sr-only';
            srSale.textContent = 'Sale price';

            const regularPrice = document.createElement('span');
            regularPrice.className = 'price__regular whitespace-nowrap';
            const fromLabel = document.createElement('small');
            fromLabel.textContent = 'From';
            regularPrice.append(
              fromLabel,
              document.createTextNode(` ${product.salePrice || product.regularPrice || ''}`)
            );

            const srRegular = document.createElement('span');
            srRegular.className = 'sr-only';
            srRegular.textContent = 'Regular price';

            const salePrice = document.createElement('span');
            salePrice.className = 'price__sale inline-flex items-center h-auto relative';
            salePrice.textContent = product.comparePrice;

            priceElement.append(srSale, regularPrice, srRegular, salePrice);
          } else {
            const regularPrice = document.createElement('span');
            regularPrice.className = 'price__regular whitespace-nowrap';
            regularPrice.textContent = product.regularPrice || product.salePrice || '';
            priceElement.append(regularPrice);
          }

          priceWrap.append(priceElement);
          details.append(priceWrap);
        }

        row.append(mediaLink, details);
        productsList.append(row);
      });

      const hasProductsResults = products.length > 0;
      productsSection.hidden = !hasProductsResults;
      productsSection.setAttribute('aria-hidden', hasProductsResults ? 'false' : 'true');
      if (resultsCta instanceof HTMLElement) {
        setAnimatedVisibility(resultsCta, hasProductsResults);
      }
    };

    const hidePagesResults = (body) => {
      if (!body) return;
      const pagesSection = body.querySelector('[data-search-pages-section]');
      const pagesList = body.querySelector('[data-search-pages-list]');
      if (!(pagesSection instanceof HTMLElement) || !(pagesList instanceof HTMLElement)) return;

      pagesList.innerHTML = '';
      pagesSection.hidden = true;
      pagesSection.setAttribute('aria-hidden', 'true');
    };

    const renderPagesResults = (body, pages) => {
      if (!body) return;
      const pagesSection = body.querySelector('[data-search-pages-section]');
      const pagesList = body.querySelector('[data-search-pages-list]');
      if (!(pagesSection instanceof HTMLElement) || !(pagesList instanceof HTMLElement)) return;

      pagesList.innerHTML = '';

      pages.forEach((page) => {
        const listItem = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'reversed-link text-base md:text-lg leading-tight font-medium';
        link.href = page.url;
        link.textContent = page.title;
        listItem.append(link);
        pagesList.append(listItem);
      });

      const hasPagesResults = pages.length > 0;
      pagesSection.hidden = !hasPagesResults;
      pagesSection.setAttribute('aria-hidden', hasPagesResults ? 'false' : 'true');
    };

    const hideCollectionsResults = (body) => {
      if (!body) return;
      const collectionsSection = body.querySelector('[data-search-collections-section]');
      const collectionsList = body.querySelector('[data-search-collections-list]');
      if (!(collectionsSection instanceof HTMLElement) || !(collectionsList instanceof HTMLElement)) return;

      collectionsList.innerHTML = '';
      collectionsSection.hidden = true;
      collectionsSection.setAttribute('aria-hidden', 'true');
    };

    const renderCollectionsResults = (body, collections) => {
      if (!body) return;
      const collectionsSection = body.querySelector('[data-search-collections-section]');
      const collectionsList = body.querySelector('[data-search-collections-list]');
      if (!(collectionsSection instanceof HTMLElement) || !(collectionsList instanceof HTMLElement)) return;

      collectionsList.innerHTML = '';

      collections.forEach((collection) => {
        const listItem = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'reversed-link text-base md:text-lg leading-tight font-medium';
        link.href = collection.url;
        link.textContent = collection.title;
        listItem.append(link);
        collectionsList.append(listItem);
      });

      const hasCollectionsResults = collections.length > 0;
      collectionsSection.hidden = !hasCollectionsResults;
      collectionsSection.setAttribute('aria-hidden', hasCollectionsResults ? 'false' : 'true');
    };

    const requestPagesResults = async (input) => {
      const body = input.closest('.header-drawer-shell__body');
      if (!body) return;
      syncSearchEmptyTerm(input);

      const searchTerm = input.value.trim();
      if (!searchTerm) {
        setSearchLoadingState(body, false);
        hidePagesResults(body);
        hideCollectionsResults(body);
        hideProductsResults(body);
        updateSearchEmptyState(input);
        return;
      }

      if (pageSearchAbortController) {
        pageSearchAbortController.abort();
      }
      pageSearchAbortController = new AbortController();
      activePageSearchRequestId += 1;
      const requestId = activePageSearchRequestId;
      setSearchLoadingState(body, true);

      try {
        const [response, productsResponse] = await Promise.all([
          fetch(getPredictiveSearchResultsUrl(searchTerm).toString(), {
            signal: pageSearchAbortController.signal,
          }),
          fetch(getPredictiveSearchProductsJsonUrl(searchTerm).toString(), {
            signal: pageSearchAbortController.signal,
          }),
        ]);
        if (!response.ok) throw new Error('Search request failed');

        const [markup, productsJson] = await Promise.all([
          response.text(),
          productsResponse.ok ? productsResponse.json() : Promise.resolve(null),
        ]);
        const parsedMarkup = new DOMParser().parseFromString(markup, 'text/html');
        const pageCards = parsedMarkup.querySelectorAll('.resource-card[data-resource-type="page"]');
        const collectionCards = parsedMarkup.querySelectorAll('.resource-card[data-resource-type="collection"]');
        const productCards = parsedMarkup.querySelectorAll('.resource-card[data-resource-type="product"]');

        const pages = Array.from(pageCards)
          .map((card) => {
            const link = card.querySelector('.resource-card__link');
            const title = card.querySelector('.resource-card__title')?.textContent?.trim();
            if (!(link instanceof HTMLAnchorElement) || !title) return null;
            return {
              url: link.href,
              title,
            };
          })
          .filter((page) => page !== null);
        const collections = Array.from(collectionCards)
          .map((card) => {
            const link = card.querySelector('.resource-card__link');
            const title = card.querySelector('.resource-card__title')?.textContent?.trim();
            if (!(link instanceof HTMLAnchorElement) || !title) return null;
            return {
              url: link.href,
              title,
            };
          })
          .filter((collection) => collection !== null);
        const vendorsByUrl = new Map();
        const jsonProducts = productsJson?.resources?.results?.products;
        if (Array.isArray(jsonProducts)) {
          jsonProducts.forEach((product) => {
            if (!product?.url) return;
            vendorsByUrl.set(new URL(product.url, window.location.origin).href, product.vendor || '');
          });
        }
        const products = Array.from(productCards)
          .map((card) => {
            const link = card.querySelector('.resource-card__link');
            const title = card.querySelector('.resource-card__title')?.textContent?.trim();
            if (!(link instanceof HTMLAnchorElement) || !title) return null;

            const image = card.querySelector('.resource-card__image');
            const regularPriceNode = card.querySelector('.price__regular .price');
            const salePriceNode = card.querySelector('.price-item--sale.price');
            const comparePriceNode = card.querySelector('.price-item--regular.compare-at-price');

            return {
              url: link.href,
              title,
              vendor: vendorsByUrl.get(link.href) || '',
              imageSrc: image instanceof HTMLImageElement ? image.currentSrc || image.src : '',
              imageAlt: image instanceof HTMLImageElement ? image.alt : '',
              regularPrice: regularPriceNode instanceof HTMLElement ? regularPriceNode.textContent?.trim() || '' : '',
              salePrice: salePriceNode instanceof HTMLElement ? salePriceNode.textContent?.trim() || '' : '',
              comparePrice: comparePriceNode instanceof HTMLElement ? comparePriceNode.textContent?.trim() || '' : '',
            };
          })
          .filter((product) => product !== null);

        renderPagesResults(body, pages);
        renderCollectionsResults(body, collections);
        renderProductsResults(body, products);
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
        hidePagesResults(body);
        hideCollectionsResults(body);
        hideProductsResults(body);
      } finally {
        if (requestId === activePageSearchRequestId) {
          setSearchLoadingState(body, false);
          updateSearchEmptyState(input);
        }
      }
    };

    const queuePagesResultsRequest = (input) => {
      if (!(input instanceof HTMLInputElement)) return;
      const body = input.closest('.header-drawer-shell__body');
      if (!body) return;
      const searchTerm = input.value.trim();

      if (searchTerm) {
        setSearchLoadingState(body, true);
      } else {
        setSearchLoadingState(body, false);
      }

      window.clearTimeout(pageSearchDebounceTimer);
      pageSearchDebounceTimer = window.setTimeout(() => {
        requestPagesResults(input);
      }, 200);
    };

    document.querySelectorAll('.search__input').forEach((input) => {
      queuePagesResultsRequest(input);
    });

    const closeDrawer = () => {
      const drawer = document.querySelector('.search-drawer.header-drawer-shell--search');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      syncScrollLock();
    };

    document.addEventListener('click', (event) => {
      const resultsLink = event.target.closest('[data-search-results-link]');
      if (resultsLink) {
        event.preventDefault();

        const input = document.querySelector('.search-drawer .search__input');
        const searchTerm = input instanceof HTMLInputElement ? input.value.trim() : '';
        const searchUrl = new URL(resultsLink.getAttribute('href') || '/search', window.location.origin);

        if (searchTerm) {
          searchUrl.searchParams.set('q', searchTerm);
        }

        window.location.href = searchUrl.toString();
        return;
      }

      const clearButton = event.target.closest('.search__field .clear');
      if (clearButton) {
        const field = clearButton.closest('.search__field');
        const input = field ? field.querySelector('.search__input') : null;
        if (input) {
          input.value = '';
          queuePagesResultsRequest(input);
          input.focus();
        }
        return;
      }

      const closeButton = event.target.closest('[data-header-drawer-close]');
      if (closeButton) {
        closeDrawer();
        return;
      }

      const mask = event.target.closest('.search-drawer.header-drawer-shell--search .header-drawer-shell__mask');
      if (mask) {
        closeDrawer();
      }
    });

    document.addEventListener('input', (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.classList.contains('search__input')) return;
      queuePagesResultsRequest(event.target);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const NUMBER_PATTERN = /-?\d+(\.\d+)?/g;

    const formatInch = (value) => {
      const converted = value / 2.54;
      const rounded = Math.round(converted * 10) / 10;

      if (!Number.isFinite(rounded)) {
        return value.toString();
      }

      if (Number.isInteger(rounded)) {
        return rounded.toString();
      }

      return rounded.toFixed(1).replace(/\.0$/, '');
    };

    const convertCmTextToInch = (cmText) => {
      if (!cmText) {
        return cmText;
      }

      return cmText.replace(NUMBER_PATTERN, (token) => {
        const cmValue = Number.parseFloat(token);

        if (!Number.isFinite(cmValue)) {
          return token;
        }

        return formatInch(cmValue);
      });
    };

    const renderUnit = (switchElement, unit) => {
      const table = switchElement.parentElement?.querySelector('[data-size-guide-table]');

      if (!table) {
        return;
      }

      const isInch = unit == 'inch';
      const toggleButton = switchElement.querySelector('[data-size-guide-unit-toggle]');
      const cells = table.querySelectorAll('[data-size-guide-cell]');

      switchElement.classList.toggle('is-inch', isInch);
      toggleButton?.setAttribute('aria-checked', isInch.toString());

      cells.forEach((cell) => {
        const cmValue = cell.getAttribute('data-cm-value') || cell.textContent?.trim() || '';

        if (isInch) {
          cell.textContent = convertCmTextToInch(cmValue);
          return;
        }

        cell.textContent = cmValue;
      });
    };

    const initUnitSwitch = (switchElement) => {
      if (switchElement.dataset.sizeGuideUnitSwitchInitialized == 'true') {
        return;
      }

      const toggleButton = switchElement.querySelector('[data-size-guide-unit-toggle]');

      switchElement.dataset.sizeGuideUnitSwitchInitialized = 'true';
      switchElement.dataset.currentUnit = 'cm';

      renderUnit(switchElement, 'cm');

      toggleButton?.addEventListener('click', () => {
        const currentUnit = switchElement.dataset.currentUnit == 'inch' ? 'inch' : 'cm';
        const nextUnit = currentUnit == 'cm' ? 'inch' : 'cm';

        switchElement.dataset.currentUnit = nextUnit;
        renderUnit(switchElement, nextUnit);
      });
    };

    const initAllUnitSwitches = (root = document) => {
      root.querySelectorAll('[data-size-guide-unit-switch]').forEach(initUnitSwitch);
    };

    if (document.readyState == 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllUnitSwitches());
    } else {
      initAllUnitSwitches();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        initAllUnitSwitches(event.target);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["split-accordion"] && !Shopify.designMode) return;
  try {
    class SplitAccordionComponent extends HTMLElement {
    connectedCallback() {
      this.activeIndex = 0;
      this.isMovingPanels = false;
      this.isSyncingDetails = false;
      this.handleClick = this.handleClick.bind(this);
      this.handleToggle = this.handleToggle.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.handleMutations = this.handleMutations.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('toggle', this.handleToggle, true);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);

      this.mediaQuery = matchMedia('(max-width: 749px)');
      this.mediaQuery.addEventListener('change', this.handleViewportChange);

      this.observer = new MutationObserver(this.handleMutations);
      if (this.itemsRegion) this.observer.observe(this.itemsRegion, { childList: true });
      if (this.panelsRegion) this.observer.observe(this.panelsRegion, { childList: true });

      this.registerPanels();
      this.initialize();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('toggle', this.handleToggle, true);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.mediaQuery?.removeEventListener('change', this.handleViewportChange);
      this.observer?.disconnect();
      clearTimeout(this.moveTimer);
      clearTimeout(this.detailsTimer);
    }

    get itemsRegion() {
      return this.querySelector(':scope > [data-split-accordion-items]');
    }

    get panelsRegion() {
      return this.querySelector(':scope > [data-split-accordion-panels]');
    }

    get rows() {
      return this.itemsRegion
        ? Array.from(this.itemsRegion.children).filter((element) => element.matches('[data-split-accordion-item]'))
        : [];
    }

    get details() {
      return this.rows
        .map((row) => row.querySelector('[data-split-accordion-details]'))
        .filter((details) => details instanceof HTMLDetailsElement);
    }

    get panels() {
      return Array.from(this.querySelectorAll('[data-split-accordion-panel]')).sort(
        (first, second) => Number(first.dataset.panelIndex) - Number(second.dataset.panelIndex)
      );
    }

    registerPanels() {
      if (!(this.panelsRegion instanceof HTMLElement)) return;

      this.isMovingPanels = true;
      this.panels.forEach((panel) => {
        if (panel.parentElement !== this.panelsRegion) this.placePanelAtHome(panel);
      });

      Array.from(this.panelsRegion.children).forEach((panel, index) => {
        panel.classList.add('split-accordion-panel');
        panel.dataset.splitAccordionPanel = '';
        panel.dataset.panelIndex = String(index);
      });

      this.releaseMoveLock();
    }

    initialize() {
      const openedIndex = this.details.findIndex((details) => details.open);
      this.activeIndex = openedIndex >= 0 ? openedIndex : 0;

      if (this.mediaQuery.matches) {
        this.updateItemStates();
        this.syncPanels();
        return;
      }

      this.activate(this.activeIndex);
    }

    handleClick(event) {
      const summary = event.target instanceof Element ? event.target.closest('summary') : null;
      if (!(summary instanceof HTMLElement) || !this.contains(summary)) return;

      const details = summary.parentElement;
      if (!(details instanceof HTMLDetailsElement)) return;

      if (this.mediaQuery.matches) return;

      if (details.open) event.preventDefault();
    }

    handleToggle(event) {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !this.contains(details)) return;
      if (this.isSyncingDetails) return;

      const index = this.details.indexOf(details);
      if (this.mediaQuery.matches) {
        if (details.open && index >= 0) this.activeIndex = index;
        this.updateItemStates();
        return;
      }

      if (details.open && index >= 0) {
        this.activate(index);
        return;
      }

      if (index === this.activeIndex) details.open = true;
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element)) return;

      const row = event.target.closest('[data-split-accordion-item]');
      const rowIndex = this.rows.indexOf(row);
      if (rowIndex >= 0) {
        this.activate(rowIndex);
        return;
      }

      const panel = event.target.closest('[data-split-accordion-panel]');
      if (panel instanceof HTMLElement) this.activate(Number(panel.dataset.panelIndex));
    }

    handleViewportChange() {
      this.resetDetailsState();
      this.updateItemStates();
      this.syncPanels();
    }

    handleMutations() {
      if (this.isMovingPanels) return;

      this.registerPanels();
      this.activeIndex = Math.min(this.activeIndex, Math.max(this.rows.length - 1, 0));
      this.activate(this.activeIndex);
    }

    activate(index) {
      if (index < 0 || index >= this.rows.length) return;

      this.activeIndex = index;

      if (this.mediaQuery.matches) {
        const activeDetails = this.details[index];
        if (activeDetails instanceof HTMLDetailsElement) activeDetails.open = true;
      } else {
        this.setDesktopDetailsState(index);
      }

      this.updateItemStates();
      this.syncPanels();
    }

    updateItemStates() {
      this.rows.forEach((row, rowIndex) => {
        const summary = row.querySelector('summary');
        const panel = this.panels[rowIndex];
        const details = this.details[rowIndex];
        const isActive = this.mediaQuery.matches ? Boolean(details?.open) : rowIndex === this.activeIndex;

        row.dataset.active = isActive ? 'true' : 'false';

        if (!(summary instanceof HTMLElement)) return;
        if (!summary.id) summary.id = `${this.dataset.splitAccordionId}-summary-${rowIndex + 1}`;
        summary.setAttribute('aria-expanded', isActive ? 'true' : 'false');

        if (panel instanceof HTMLElement) {
          if (!panel.id) panel.id = `${this.dataset.splitAccordionId}-panel-${rowIndex + 1}`;
          summary.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'region');
          panel.setAttribute('aria-labelledby', summary.id);
          panel.dataset.panelActive = isActive ? 'true' : 'false';
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          panel.toggleAttribute('inert', !isActive);
        } else {
          summary.removeAttribute('aria-controls');
        }
      });

      this.panels.slice(this.rows.length).forEach((panel) => {
        panel.dataset.panelActive = 'false';
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
      });

      this.syncMediaPlayback();
    }

    syncMediaPlayback() {
      requestAnimationFrame(() => {
        this.panels.forEach((panel) => {
          const isActive = panel.dataset.panelActive === 'true';

          panel.querySelectorAll('deferred-media[autoplay]').forEach((media) => {
            if (isActive) {
              if (typeof media.syncAutoplay === 'function') media.syncAutoplay();
            } else if (typeof media.pauseMedia === 'function') {
              media.pauseMedia();
            }
          });
        });
      });
    }

    syncPanels() {
      if (!(this.panelsRegion instanceof HTMLElement)) return;

      this.isMovingPanels = true;
      if (this.mediaQuery.matches) {
        this.syncMobilePanels();
        this.releaseMoveLock();
        return;
      }

      this.panels.forEach((panel) => {
        if (panel.parentElement !== this.panelsRegion) this.placePanelAtHome(panel);
      });

      this.releaseMoveLock();
    }

    get mobileHosts() {
      return this.rows
        .map((row) => row.querySelector('[data-split-accordion-mobile-panel-host]'))
        .filter((host) => host instanceof HTMLElement);
    }

    syncMobilePanels() {
      const hosts = this.mobileHosts;

      this.panels.forEach((panel, index) => {
        const host = hosts[index];
        if (host instanceof HTMLElement) {
          if (panel.parentElement !== host) host.append(panel);
        } else if (panel.parentElement !== this.panelsRegion) {
          this.placePanelAtHome(panel);
        }
      });
    }

    setDesktopDetailsState(index) {
      this.isSyncingDetails = true;
      this.details.forEach((details, detailsIndex) => {
        details.open = detailsIndex === index;
      });
      this.releaseDetailsLock();
    }

    resetDetailsState() {
      this.isSyncingDetails = true;
      this.details.forEach((details, index) => {
        details.open = index === this.activeIndex;
      });
      this.releaseDetailsLock();
    }

    releaseDetailsLock() {
      clearTimeout(this.detailsTimer);
      this.detailsTimer = setTimeout(() => {
        this.isSyncingDetails = false;
      });
    }

    placePanelAtHome(panel) {
      if (!(this.panelsRegion instanceof HTMLElement)) return;

      const panelIndex = Number(panel.dataset.panelIndex);
      const nextPanel = Array.from(this.panelsRegion.children).find(
        (candidate) => Number(candidate.dataset.panelIndex) > panelIndex
      );

      if (nextPanel) {
        this.panelsRegion.insertBefore(panel, nextPanel);
      } else {
        this.panelsRegion.append(panel);
      }
    }

    releaseMoveLock() {
      clearTimeout(this.moveTimer);
      this.moveTimer = setTimeout(() => {
        this.isMovingPanels = false;
      });
    }
  }

  if (!customElements.get('split-accordion-component')) {
    customElements.define('split-accordion-component', SplitAccordionComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tab-layout"] && !Shopify.designMode) return;
  try {
    class TabLayoutComponent extends HTMLElement {
    connectedCallback() {
      this.activeIndex = 0;
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, { childList: true, subtree: true });
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.observer?.disconnect();
    }

    getElements() {
      const tabsRegion = this.querySelector(':scope > [data-tab-layout-tabs]');
      const panelsRegion = this.querySelector(':scope > [data-tab-layout-panels]');
      const tabs = tabsRegion ? Array.from(tabsRegion.querySelectorAll(':scope > [data-tab-layout-tab]')) : [];
      const panels = panelsRegion ? Array.from(panelsRegion.children) : [];

      return { tabs, panels };
    }

    sync() {
      const { tabs, panels } = this.getElements();
      const pairCount = Math.min(tabs.length, panels.length);

      if (pairCount === 0) {
        tabs.forEach((tab) => this.updateTab(tab, false, false));
        panels.forEach((panel) => this.updatePanel(panel, null, false));
        return;
      }

      this.activeIndex = Math.min(this.activeIndex, pairCount - 1);

      tabs.forEach((tab, index) => {
        const panel = panels[index];
        const isPaired = index < pairCount;
        const isActive = isPaired && index === this.activeIndex;

        this.updateTab(tab, panel, isActive);
        if (panel) this.updatePanel(panel, tab, isActive);
      });

      panels.slice(tabs.length).forEach((panel) => this.updatePanel(panel, null, false));
    }

    updateTab(tab, panel, isActive) {
      const isPaired = panel instanceof HTMLElement;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      tab.setAttribute('aria-disabled', isPaired ? 'false' : 'true');

      if (isPaired) {
        if (!panel.id) panel.id = `${this.dataset.tabLayoutId}-panel-${this.panelIndex(panel) + 1}`;
        tab.setAttribute('aria-controls', panel.id);
      } else {
        tab.removeAttribute('aria-controls');
      }
    }

    updatePanel(panel, tab, isActive) {
      panel.classList.add('tab-layout-panel');
      panel.setAttribute('role', 'tabpanel');
      panel.toggleAttribute('hidden', !isActive);

      if (tab instanceof HTMLElement) {
        if (!tab.id) tab.id = `${this.dataset.tabLayoutId}-tab-${this.tabIndex(tab) + 1}`;
        panel.setAttribute('aria-labelledby', tab.id);
      } else {
        panel.removeAttribute('aria-labelledby');
      }
    }

    tabIndex(tab) {
      return this.getElements().tabs.indexOf(tab);
    }

    panelIndex(panel) {
      return this.getElements().panels.indexOf(panel);
    }

    activate(index, moveFocus = false) {
      const { tabs, panels } = this.getElements();
      const pairCount = Math.min(tabs.length, panels.length);
      if (index < 0 || index >= pairCount) return;

      this.activeIndex = index;
      this.sync();
      if (moveFocus) tabs[index].focus();
    }

    handleClick(event) {
      const tab = event.target instanceof Element ? event.target.closest('[data-tab-layout-tab]') : null;
      if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;
      this.activate(this.tabIndex(tab));
    }

    handleKeydown(event) {
      const tab = event.target instanceof Element ? event.target.closest('[data-tab-layout-tab]') : null;
      if (!(tab instanceof HTMLButtonElement) || !this.contains(tab)) return;

      const { tabs, panels } = this.getElements();
      const pairCount = Math.min(tabs.length, panels.length);
      if (pairCount === 0) return;

      const currentIndex = tabs.indexOf(tab);
      if (currentIndex < 0 || currentIndex >= pairCount) return;

      const isRtl = getComputedStyle(this).direction === 'rtl';
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = currentIndex + (isRtl ? -1 : 1);
      if (event.key === 'ArrowLeft') nextIndex = currentIndex + (isRtl ? 1 : -1);
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = pairCount - 1;
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      nextIndex = (nextIndex + pairCount) % pairCount;
      this.activate(nextIndex, true);
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element)) return;

      const { tabs, panels } = this.getElements();
      const tabIndex = tabs.findIndex((tab) => tab === event.target || tab.contains(event.target));
      if (tabIndex >= 0) {
        this.activate(tabIndex);
        return;
      }

      const panelIndex = panels.findIndex((panel) => panel === event.target || panel.contains(event.target));
      if (panelIndex >= 0) this.activate(panelIndex);
    }
  }

  if (!customElements.get('tab-layout-component')) {
    customElements.define('tab-layout-component', TabLayoutComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
